"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDonationFormCreatedMockData = exports.buildSubscriptionAmountUpdatedOrganizationMockData = exports.buildRecurringDonationCancelledOrganizationMockData = exports.buildDonationReceivedOrganizationMockData = void 0;
const mobile_app_links_1 = require("../../helpers/mobile-app-links");
const organization_facing_base_1 = require("./organization-facing-base");
const buildDonationReceivedOrganizationMockData = ({ locale = "en", subject = "$120.00 donation received from Jane Donor", formTitle = "Sandbox Donation Form", amount = "$120.00", donorFirstName = "Jane", donorLastName = "Donor", donorEmail = "jane.donor@example.com", address = "500 Park Avenue, New York, NY", fundName = "Scholarship Fund", tribute = null, inHonourName = null, isPadOrAch = false, isChequeAwaitingPayment = false, isDaf = false, currency = "usd", additionalBuyerQuestions = [{ question: "How did you hear about us?", answer: "From a friend" }], formattedSavedAmount = "$3.78", transactionNumber = "42nd", viewPaymentLink = "https://www.zeffy.com/en-US/o/payments", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    formTitle,
    amount,
    donorFirstName,
    donorLastName,
    donorEmail,
    address,
    fundName,
    tribute,
    inHonourName,
    isPadOrAch,
    isChequeAwaitingPayment,
    isDaf,
    currency,
    additionalBuyerQuestions,
    formattedSavedAmount,
    transactionNumber,
    viewPaymentLink,
    appStoreUrl: (0, mobile_app_links_1.getAppStoreUrl)(),
    playStoreUrl: (0, mobile_app_links_1.getPlayStoreUrl)(),
});
exports.buildDonationReceivedOrganizationMockData = buildDonationReceivedOrganizationMockData;
const buildRecurringDonationCancelledOrganizationMockData = ({ locale = "en", subject = "Your donor's recurring donation has been cancelled", firstName = "John", donorFirstName = "Jane", donorLastName = "Donor", donorEmail = "jane.donor@example.com", churnReason = "via their donor dashboard", cancellationReason = "I can no longer afford it", cancellationFeedback = "Thank you for everything you do.", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    donorFirstName,
    donorLastName,
    donorEmail,
    churnReason,
    cancellationReason,
    cancellationFeedback,
});
exports.buildRecurringDonationCancelledOrganizationMockData = buildRecurringDonationCancelledOrganizationMockData;
const buildSubscriptionAmountUpdatedOrganizationMockData = ({ locale = "en", subject = "Your donor's recurring donation has been updated", firstName = "John", donorFirstName = "Jane", donorLastName = "Donor", previousAmount = "$25.00", newAmount = "$40.00", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    donorFirstName,
    donorLastName,
    previousAmount,
    newAmount,
});
exports.buildSubscriptionAmountUpdatedOrganizationMockData = buildSubscriptionAmountUpdatedOrganizationMockData;
const buildDonationFormCreatedMockData = ({ locale = "en", subject = "Sandbox Donation Form is ready!", firstName = "John", formTitle = "Sandbox Donation Form", formUrl = "https://www.zeffy.com/en-US/donation-form/sandbox-donation-form", showBankAccountNote = false, bankAccountUrl = "https://www.zeffy.com/en-US/o/bank", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    formTitle,
    formUrl,
    showBankAccountNote,
    bankAccountUrl,
});
exports.buildDonationFormCreatedMockData = buildDonationFormCreatedMockData;
